import type {materialFunctionsRouteApi} from "./-route-api";
import type {z} from "zod";

import {listMaterialFunctionsSearchSchema as applicationListMaterialFunctionsSearchSchema} from "@project/application/engineering/material-functions";

export const listMaterialFunctionsSearchSchema =
  applicationListMaterialFunctionsSearchSchema.transform((search) => ({
    ...search,
    state: search.state === "DELETED" ? ("DELETED" as const) : ("ACTIVE" as const),
  }));

export type ListMaterialFunctionsSearch = z.output<typeof listMaterialFunctionsSearchSchema>;

export type MaterialFunctionsNavigateFn = ReturnType<typeof materialFunctionsRouteApi.useNavigate>;
